// extracted by mini-css-extract-plugin
export default {"step":"styles_step__dpBfJ","step-circle":"styles_step-circle__wGFDV","dotted":"styles_dotted__vZhoN","text-container":"styles_text-container__fpTTI"};